import React, { useState } from 'react'

import AutocompleteFilter from './Autocomplete'

const Status = ({ selectedStatuses, setSelectedStatuses, ...props }) => {
  const [queryString, setQueryString] = useState('')

  const options = [
    { id: 1, name: 'Open' },
    { id: 2, name: 'Won' },
    { id: 3, name: 'Lost' },
  ]

  return (
    <>
      <AutocompleteFilter
        {...props}
        multiple
        options={options}
        value={selectedStatuses}
        setQueryString={setQueryString}
        getOptionLabel={(customer) => customer.name}
        onChange={(_, value) => setSelectedStatuses(value)}
        placeholder={'Status'}
      />
    </>
  )
}

export default Status
